import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { XlXuLySuCoService} from '../xu-ly/xl-xu-ly-su-co/xl-xu-ly-su-co.service';
import { ModalDirective } from 'ng2-bootstrap';
import { DieuHanhXulYService } from 'app/dieu-hanh/dieu-hanh.service';

@Component({    
    selector: 'vnpt-header',
    styleUrls:['../../assets/css/table-scroll.css'],
    templateUrl: './header.component.html',
    providers:[
        XlXuLySuCoService,
        DieuHanhXulYService
    ]
})
export class HeaderComponent implements OnInit {
    @ViewChild("lgModalHienThiChiTiet") lgModalHienThiChiTiet: ModalDirective;
    @ViewChild("lgModalHienThi") lgModalHienThi: ModalDirective;
    
    hoTenNhanVien:string = this.auth.user.HoTen;
    constructor(
        public auth:AuthService,
        private serviceCB:XlXuLySuCoService,
        private serviceDHXL: DieuHanhXulYService,
    ) { }

    DanhSachCB:any[]=[];
    TongCB:number=0;
    TongSLG:number=0;
    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    maxSize: number = 10;
    fromRow:number = 0;
    toRow:number = 0;
    status:boolean=false;
    ngOnInit() { 
       this.auth.loadMenu(this.auth.user.TaiKhoan);
        this.auth.Load_DanhSach_CanhBao();  
        this.Load_canhBaoChiDao();  
    }

    Load_DanhSach_CanhBao(){
        this.serviceCB.DanhSach_CanhBao().subscribe(
            resp=>{
                this.DanhSachCB = resp;
                if(resp.length > 0){
                    this.TongCB = resp[0].TongCanhBao;
                    this.TongSLG = resp[0].TongSLG;
                }                    
                else{
                    this.TongCB = 0;
                    this.TongSLG = 0;
                }                
            }
        )
    }
    Stt:number=1;
    dsChiTietPhieu:any=[];
    XemChiTietSoLanGoi(paging){
        this.Stt = ((paging-1)*this.maxSize) +1;
        if(this.Stt == 0) this.Stt=1;
        this.lgModalHienThiChiTiet.show();
        let TT={
            page:paging,
            pagesize:this.maxSize
        }
        this.serviceCB.ds_ChiTietSoLanGoi(TT).subscribe(
            resp=>{                
                this.dsChiTietPhieu = resp;
                this.totalPages = 0;
                if (this.dsChiTietPhieu != null && this.dsChiTietPhieu.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (resp[0]).TOTALROWS;
                    // tính tổng số trang cần phân dựa vào tổng records
                    this.fromRow = (this.paging - 1)  * this.maxSize +1;
                    this.toRow = this.fromRow + this.dsChiTietPhieu.length -1;
                    this.totalPages = Math.ceil(this.totalCount / this.maxSize);                    
                }
            }
        )
    }
    myFunction(val) {
        var dots = document.getElementById("dots" + val);
        var moreText = document.getElementById("more" + val);
        var btnText = document.getElementById("bt" + val);
    
        if (dots.style.display === "none") {
          dots.style.display = "inline";
          btnText.innerText = 'Xem thêm';
          moreText.style.display = "none";
    
        } else {
          dots.style.display = "none";
          btnText.innerText = 'Ẩn';
          moreText.style.display = "inline";
        }
    }
    HienThiHTML: string = "";
    TieuDeModal: string = "";
    XL: any = {};
    onselectLichSu(item) {    
          console.log(item);              
          this.XL.IDYEUCAU = item.MAPA;    
          this.lgModalHienThi.show();
          this.HienThiHTML = "lich_su";
          this.TieuDeModal = "Lịch sử xử lý yêu cầu: PAKH:" + item.MAPA +"/Điện thoại:" + item.SOTHUEBAO +"/Khách hàng:" + item.TENKHACHHANG;
    }
    public pageChanged(event:any):void {                  
        this.XemChiTietSoLanGoi(event.page);    
    }
    tongCanhBaoChiDao:number=0;
    dsCanhBaoChiDao:any[] = [];
    Load_canhBaoChiDao(){
      let TT={
        IdNhanVien:this.auth.user.Id
      };
      this.serviceDHXL.canhBaoChidao(TT).subscribe(
        resp=>{
          this.dsCanhBaoChiDao = resp;
          this.tongCanhBaoChiDao = resp.length;
        }
      )    
    }

    clickChangePwd() {
        var idtokenxt = localStorage.getItem('scnnttidtoken');
        if (idtokenxt && this.auth.systemConfig.sso.change_pwd_url) {
            window.location.href = this.auth.systemConfig.sso.change_pwd_url;
        } else {
            this.auth.sendToModal({ type: 'USER_CHANGE_PWD' });
        }
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/header/header.component.ts